module.exports = __webpack_public_path__ + "img/location-text-img_960.363b2372.jpg";